"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PluginBase = void 0;
class PluginBase {
    getNewSongFormComponent() {
        return null;
    }
    getEditSongFormComponent() {
        return null;
    }
    getMusicDetailPanels() {
        return null;
    }
    getHomePanelWidget() {
        return null;
    }
}
exports.PluginBase = PluginBase;
//# sourceMappingURL=PluginBase.js.map